import React from "react";

import { Box, BoxProps } from "../Box";

export const CardTitle = (props: BoxProps) => (
  <Box mb={2} textStyle={"heading-normal-medium"} {...props} />
);
